import type { AdminFeedbackType } from '../../types/feedback';

type FeedbackButtonsProps = {
  onFeedback: (type: AdminFeedbackType) => void;
  disabled?: boolean;
};

const BUTTONS: Array<{ type: AdminFeedbackType; label: string; color: string }> = [
  {
    type: 'good_answer',
    label: 'Bra svar',
    color: 'border-emerald-400 text-emerald-600 hover:bg-emerald-50',
  },
  { type: 'bad_answer', label: 'Fel svar', color: 'border-red-400 text-red-600 hover:bg-red-50' },
  {
    type: 'missing_knowledge',
    label: 'Saknar kunskap',
    color: 'border-amber-400 text-amber-600 hover:bg-amber-50',
  },
  {
    type: 'wrong_intent',
    label: 'Fel intent',
    color: 'border-purple-400 text-purple-600 hover:bg-purple-50',
  },
  {
    type: 'should_escalate',
    label: 'Borde eskaleras',
    color: 'border-orange-400 text-orange-600 hover:bg-orange-50',
  },
  { type: 'ui_bug', label: 'UI-bugg', color: 'border-blue-400 text-blue-600 hover:bg-blue-50' },
  {
    type: 'backend_bug',
    label: 'Backend-bugg',
    color: 'border-slate-400 text-slate-600 hover:bg-slate-50',
  },
];

export const FeedbackButtons = ({ onFeedback, disabled }: FeedbackButtonsProps) => {
  return (
    <div className="flex flex-wrap gap-1.5 pt-1">
      {BUTTONS.map((btn) => (
        <button
          key={btn.type}
          type="button"
          onClick={() => onFeedback(btn.type)}
          disabled={disabled}
          className={`inline-flex items-center rounded-sm border px-2 py-1 text-[11px] font-medium transition-colors duration-150 ${btn.color} disabled:opacity-40 disabled:cursor-not-allowed`}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};
